import React from 'react'
import { ExtendCurrency } from 'src/enums'
import Crncy from 'src/localization/Crncy'
import Trns from 'src/localization/Trns'
import { RecurrencePeriod } from 'src/models/recurrence.models'
import { convertUTCRecurringLabel, extendWeekdays } from 'src/utils/date.utils'

interface RecurrenceAmountAndFrequencyLabelProps {
  className?: string
  balance: number
  period: RecurrencePeriod
  interval: number
  // terminator: RecurrenceTerminator
  // count: number
  // until?: string
  byWeekDay?: number
  byMonthDay?: number
  byYearDay?: number
  // prevRecurrenceAt?: string
  // nextRecurrenceAt?: string
  // currentCount: number
  // remainingCount?: number
  timezone: string
  currency: ExtendCurrency
}

const RecurrenceAmountAndFrequencyLabel: React.FC<
  RecurrenceAmountAndFrequencyLabelProps
> = (props): React.ReactElement => {
  switch (props.period) {
    case RecurrencePeriod.Daily: {
      return props.interval === 1 ? (
        <Trns
          source={'${amount} every day'}
          expressions={{
            amount: <Crncy currency={props.currency} amount={props.balance} />,
          }}
        />
      ) : (
        <Trns
          source={'${amount} every ${interval} days'}
          expressions={{
            amount: <Crncy currency={props.currency} amount={props.balance} />,
            interval: `${props.interval}`,
          }}
        />
      )
    }
    case RecurrencePeriod.Weekly: {
      return props.interval === 1 ? (
        <Trns
          source={'${amount} every week, on ${byWeekDay}'}
          expressions={{
            amount: <Crncy currency={props.currency} amount={props.balance} />,
            byWeekDay: extendWeekdays(props.byWeekDay),
          }}
        />
      ) : (
        <Trns
          source={'${amount} every ${interval} weeks, on ${byWeekDay}'}
          expressions={{
            amount: <Crncy currency={props.currency} amount={props.balance} />,
            interval: `${props.interval}`,
            byWeekDay: extendWeekdays(props.byWeekDay),
          }}
        />
      )
    }
    case RecurrencePeriod.Monthly: {
      return props.interval === 1 ? (
        <Trns
          source={'${amount} every month, on the ${byMonthDay}'}
          expressions={{
            amount: <Crncy currency={props.currency} amount={props.balance} />,
            byMonthDay: convertUTCRecurringLabel(
              `${props.byMonthDay}-01-3000`,
              'DD-MM-YYYY',
              props.timezone,
            ).format('Do'),
          }}
        />
      ) : (
        <Trns
          source={'${amount} every ${interval} months, on the ${byMonthDay}'}
          expressions={{
            amount: <Crncy currency={props.currency} amount={props.balance} />,
            interval: `${props.interval}`,
            byMonthDay: convertUTCRecurringLabel(
              `${props.byMonthDay}-01-3000`,
              'DD-MM-YYYY',
              props.timezone,
            ).format('Do'),
          }}
        />
      )
    }
    case RecurrencePeriod.Yearly: {
      return (
        <Trns
          source={'${amount} every year, on ${byYearDay}'}
          expressions={{
            amount: <Crncy currency={props.currency} amount={props.balance} />,
            byYearDay: convertUTCRecurringLabel(
              `${props.byYearDay} 3000`,
              'DDD YYYY',
              props.timezone,
            ).format('MMMM D'),
          }}
        />
      )
    }
  }
}

export default RecurrenceAmountAndFrequencyLabel
